<img [src]="model.image.file.url" [ngStyle]="model.style" [style.width.px]="model.width" [style.height.px]="model.height" />
